function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.286 1.3566c3.773 3.1132 5.6596 6.0894 5.6596 8.9285 0 3.4814-2.2492 5.3424-5.0817 5.3424-2.8324 0-4.239-2.6641-4.239-4.462 0-2.139 1.0597-2.5575 2.8928-5.9855.4993-.9337.7553-2.2082.7682-3.8234z"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.3726 7.8455c.0066.825.1374 1.4759.3924 1.9528.9362 1.751 1.4774 1.9646 1.4774 3.0572 0 .9183-.7183 2.279-2.165 2.279-1.4468 0-2.5956-.9505-2.5956-2.7287 0-1.4501.9636-2.9702 2.8908-4.5603z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.2972 11.3364c.0034.4299.0716.769.2045 1.0175.4878.9124.7699 1.0238.7699 1.593 0 .4786-.3744 1.1876-1.1282 1.1876s-1.3525-.4953-1.3525-1.4218c0-.7557.5021-1.5478 1.5063-2.3763z"
})));

var SvgGas = function SvgGas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 17",
    className: "icon icon-gas",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gas.b9d8ee51.svg";
export { ForwardRef as ReactComponent };